import * as Sentry from '@sentry/react';
import React from 'react';
import { useLocation } from 'react-router-dom';

const sentry_dsn = process.env.REACT_APP_SENTRY_DSN ?? '';
const release = process.env.REACT_APP_RELEASE ?? '';

export default () => {
  Sentry.init({
    dsn: sentry_dsn,
    release,
    integrations: [
      new Sentry.BrowserTracing({
        // See docs for support of different versions of variation of React router
        // https://docs.sentry.io/platforms/javascript/guides/react/configuration/integrations/react-router/
        routingInstrumentation: Sentry.reactRouterV6Instrumentation(
          React.useEffect,
          useLocation,
          // useNaviga,
          // createRoutesFromChildren,
          // matchRoutes
        ),
      }),
      new Sentry.Replay(),
    ],

    // Set tracesSampleRate to 1.0 to capture 100%
    // of transactions for performance monitoring.
    tracesSampleRate: 1.0,

    // Set `tracePropagationTargets` to control for which URLs distributed tracing should be enabled
    tracePropagationTargets: [/^https:\/\/admin\.speedvacanze.it\.it\//],

    // This sets the sample rate to be 10%. You may want this to be 100% while
    // in development and sample at a lower rate in production
    replaysSessionSampleRate: 0.1,
    // If the entire session is not sampled, use the below sample rate to sample
    // sessions when an error occurs.
    replaysOnErrorSampleRate: 1.0,
  });
};
